import { Fee, CancellationFee, PackageProduct } from "app/shared/model";
import { ProductsListState } from "./state";

function getRoot(state:any): ProductsListState {
    return state.reducer;
}

export function getSearchTerm(state: any) {
    const root = getRoot(state);
    return root.searchTerm;
}

export function getSelectedProductType(state: any) {
    const root = getRoot(state);
    return root.selectedProductType;
}

export function getFilteredData(state: any) {
    const root = getRoot(state);
    return root.filteredData;
}

export function getAccommodationProductsData(state:any){
    const root = getRoot(state);
    return root.accommodationProducts;
}

export function getCourseProductsData(state:any){
    const root = getRoot(state);
    return root.courseProducts;
}

export function getCourseById(state:any){
    const root = getRoot(state);
    return root.courseProduct;
}

export function getAccommodationById(state:any){
    const root = getRoot(state);
    return root.accommodation;
}

export function getTransferById(state:any){
    const root = getRoot(state);
    return root.transfer;
}

export function getAddonById(state:any){
    const root = getRoot(state);
    return root.addon;
}

export function getAddOnsProductsData(state:any){
    const root = getRoot(state);
    return root.addOnProducts;
}

export const getFeesProductsData = (state: any) => {
    const root = getRoot(state);
    return root.feesProducts;
};

export const getCancellationFeesProductsData = (state: any) => {
    const root = getRoot(state);
    return root.cancellationFeeProducts;
};

export function getCancellationFeeById(state: any, id: number) {
    const root = getRoot(state);
    return (root.cancellationFeeProducts ?? []).filter((f: CancellationFee) => Number(f.id) === Number(id));
}

export function getDraftCancellationFeeProduct(state: any) {
    const root = getRoot(state);
    return root.draftCancellationFeeProduct;
}

export function getCancellationFeesData(state: any) {
    const root = getRoot(state);
    if (root.selectedProductType === 'CancellationFees' && Array.isArray(root.filteredData)) {
        return root.filteredData as unknown as CancellationFee[];
    }
    return root.cancellationFeeProducts;
}

export const getPackageProductsData = (state: any) => {
    const root = getRoot(state);
    return root.packageProducts;
};

export function getFeeById(state:any, id: number){
    const root = getRoot(state);
    return (root.feesProducts ?? []).filter((f: Fee) => Number(f.id) === Number(id));
}

export function getPackageById(state:any){
    const root = getRoot(state);
    return root.packageProduct;
}

export function getDraftFeeProduct(state: any) {
    const root = getRoot(state);
    return root.draftProduct;
}

export function getDraftPackageProduct(state: any) {
    const root = getRoot(state);
    return root.draftPackageProduct;
}

export function getFeesData(state:any){
    const root = getRoot(state);
    if (root.selectedProductType === 'Fees' && Array.isArray(root.filteredData)) {
        return root.filteredData as unknown as Fee[];
    }
    return root.feesProducts;
}

export function getPackagesData(state:any){
    const root = getRoot(state);
    if (root.selectedProductType === 'Packages' && Array.isArray(root.filteredData)) {
        return root.filteredData as PackageProduct[];
    }
    return root.packageProducts;
}

export function getTransfersProductsData(state:any){
    const root = getRoot(state);
    return root.transferProducts;
}

export function getCourseIntensity(state:any){
    const root = getRoot(state);
    return root.courseIntensity;
}

export function getLanguages(state:any){
    const root = getRoot(state);
    return root.languages;
}

export function getProductDivisions(state:any){
    const root = getRoot(state);
    return root.productDivisions;
}

export function getCourseName(state:any){
    const root = getRoot(state);
    return root.name;
}

export function getUpdatedCourseIntensityId(state:any){
    const root = getRoot(state);
    return root.intensityId;
}

export function getUpdatedCourseDivisionId(state:any){
    const root = getRoot(state);
    return root.divisionId;
}

export function getFormErrors(state: any){
    const root = getRoot(state);
    return root.formErrors;
}

export function getDraftAccommodationProduct(state: any) {
    const root = getRoot(state);
    return root.draftProduct;
}

export function getUnitTypes(state:any){
    const root = getRoot(state);
    return root.unitTypes;
}

export const getTypes = (state: any): { Id: number; Name: string }[] =>
    state.lookup?.types ?? [];
  
  export const getDivisions = (state: any): { Id: number; Name: string }[] =>
    state.lookup?.divisions ?? [];
  
export function getDraftAddOnProduct(state: any) {
    const root = getRoot(state);
    return root.draftAddOnProduct;
}

export function getAccommodationTypes(state:any){
    const root = getRoot(state);
    return root.accommodationTypes;
}

export function getTransferTypes(state: any) {
    const root = getRoot(state);
    return root.transferTypes;
}

export function getTransferPorts(state: any) {
    const root = getRoot(state);
    return root.transferPorts;
}

export function getDraftTransferProduct(state: any) {
    const root = getRoot(state);
    return root.draftTransferProduct;
}

export function getProductCategories(state: any) {
    const root = getRoot(state);
    return root.productCategories;
}
export function getAccountCategories(state: any) {
    const root = getRoot(state);
    return root.accountCategories;
}
export function getCommissionCategories(state: any) {
    const root = getRoot(state);
    return root.commissionCategories;
}

// export function getRoomTypes(state:any){
//     const root = getRoot(state);
//     return root.roomTypes;
// }

// export function getBathroomTypes(state:any){
//     const root = getRoot(state);
//     return root.bathroomTypes;
// }

// export function getBoardBasis(state:any){
//     const root = getRoot(state);
//     return root.boardBasis;
// }

